import React, { FunctionComponent } from 'react';
import { Header, Icon } from 'semantic-ui-react';
import withStyles from 'react-jss';
import ReactGA from 'react-ga4';

export interface Props {
  classes: { header: string };
}

const styles = {
  header: {
    marginTop: '12.5rem !important',
  },
};

const NotFound: FunctionComponent<Props> = ({ classes }: Props) => {
  const page = location.pathname + location.search;
  ReactGA.set({
    page,
    Error: 'PageNotFound: 404',
  });

  return (
    <div>
      <Header className={classes.header} as="h2" icon textAlign="center">
        <Icon name="configure" circular />

        <Header.Content>We&apos;re sorry - Page not found.</Header.Content>
      </Header>
    </div>
  );
};

export default withStyles(styles)(NotFound);
